import { useQueryClient } from '@tanstack/react-query';
import {
  useUpgradeSubscription as useGeneratedUpgrade,
  getGetSubscriptionInvoicesQueryKey,
} from '@/shared/api/generated/subscriptions';
import { getGetCurrentUserQueryKey } from '@/shared/api/generated/current-user';

export const useUpgradeSubscription = () => {
  const queryClient = useQueryClient();
  return useGeneratedUpgrade({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getGetCurrentUserQueryKey() });
        queryClient.invalidateQueries({ queryKey: getGetSubscriptionInvoicesQueryKey() });
      },
    },
  });
};
